import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Rows = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 4.5C2.5 3.83333 2.9 2.5 4.5 2.5H11.5C12.1667 2.5 13.5 2.9 13.5 4.5M2.5 11.5C2.5 12.1667 2.9 13.5 4.5 13.5H11.5C12.1667 13.5 13.5 13.1 13.5 11.5M4.5 10.5H11.5C12.6046 10.5 13.5 9.60457 13.5 8.5V7.5C13.5 6.39543 12.6046 5.5 11.5 5.5H4.5C3.39543 5.5 2.5 6.39543 2.5 7.5V8.5C2.5 9.60457 3.39543 10.5 4.5 10.5Z"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
      />
    </svg>
  ),
)
Rows.displayName = 'Rows'

export default Rows
